/**
 * Counts numbers up the first time they scroll into view.
 *
 * Mark any element with data-count-up. Its text content is the final value and
 * stays rendered in the HTML, so the correct number shows without JS, without an
 * observer, and for anyone who prefers reduced motion — the counter only rewinds
 * it once it knows it can animate.
 *
 *   <span data-count-up>78%</span>
 *   <span data-count-up data-count-duration="2000">1,200 mg</span>
 *
 * The number is pulled out of the string and whatever surrounds it is preserved,
 * so "~4%", "300+", "$50" and "4.8/5" all count correctly.
 */
(function () {
  var SELECTOR = '[data-count-up]';
  var DEFAULT_DURATION = 1400;

  var supported =
    'IntersectionObserver' in window &&
    typeof window.requestAnimationFrame === 'function';

  var reduced =
    window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches;

  if (!supported || reduced) return;

  function parse(text) {
    var match = text.match(/-?\d[\d,]*(\.\d+)?/);
    if (!match) return null;

    var raw = match[0];
    var value = parseFloat(raw.replace(/,/g, ''));
    if (isNaN(value)) return null;

    return {
      original: text,
      value: value,
      prefix: text.slice(0, match.index),
      suffix: text.slice(match.index + raw.length),
      decimals: (raw.split('.')[1] || '').length,
      grouped: raw.indexOf(',') !== -1
    };
  }

  function format(n, spec) {
    var out = n.toFixed(spec.decimals);

    if (spec.grouped) {
      var parts = out.split('.');
      parts[0] = parts[0].replace(/\B(?=(\d{3})+(?!\d))/g, ',');
      out = parts.join('.');
    }

    return spec.prefix + out + spec.suffix;
  }

  function run(el) {
    var spec = el.countUpSpec;
    var duration = parseInt(el.getAttribute('data-count-duration'), 10) || DEFAULT_DURATION;
    var startedAt = null;

    function step(now) {
      if (startedAt === null) startedAt = now;

      var t = Math.min((now - startedAt) / duration, 1);
      var eased = 1 - Math.pow(1 - t, 3);

      if (t < 1) {
        el.textContent = format(spec.value * eased, spec);
        window.requestAnimationFrame(step);
      } else {
        // Land on the author's exact string, not a rounded rebuild of it.
        el.textContent = spec.original;
      }
    }

    window.requestAnimationFrame(step);
  }

  var observer = new IntersectionObserver(
    function (entries) {
      entries.forEach(function (entry) {
        if (!entry.isIntersecting) return;
        observer.unobserve(entry.target);
        run(entry.target);
      });
    },
    { threshold: 0.4 }
  );

  function init(root) {
    var scope = root && root.querySelectorAll ? root : document;

    Array.prototype.forEach.call(scope.querySelectorAll(SELECTOR), function (el) {
      if (el.countUpReady) return;

      var spec = parse((el.textContent || '').trim());
      if (!spec) return;

      el.countUpReady = true;
      el.countUpSpec = spec;
      el.textContent = format(0, spec);
      observer.observe(el);
    });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', function () {
      init(document);
    });
  } else {
    init(document);
  }

  // Sections re-render as they are edited in the theme editor.
  document.addEventListener('shopify:section:load', function (event) {
    init(event.target);
  });
})();
